import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import TextField from '@material-ui/core/TextField';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import MenuItem from '@material-ui/core/MenuItem';
import KobooButton from '../Layout/KobooButton';
import * as routes from '../../constants/routes';
import { getRenters } from '../../store/renters/actions';
import Spinner from '../Layout/Spinner';
import { postBike } from '../../store/bikes/actions';
import { getSites } from '../../store/sites/actions';
import defaultStyles from '../../constants/stylesDefault';
import Loader from '../Layout/Loader';
import KobooTextField from '../Layout/KobooTextField.jsx';
import withAuthorization from '../../hoc/withAuthorization';

const styles = theme => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: 'row',
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: 200,
  },
});

const byPropKey = (propertyName, value) => () => ({
  [propertyName]: value,
});

const INITIAL_STATE = {
  sites: [],
  site_id: '',
  renter_id: '',
  mac_address: '',
  padlock_number: '',
  number: '',
  rfid: '',
  type: 0,
  padlock_type: 0,
  manufacturer_id: '',
  is_electric: false,
};

export class AddBikeForm extends Component {
  constructor(props) {
    super(props);
    this.state = { ...INITIAL_STATE };
  }

  static propTypes = {
    authUser: PropTypes.object,
    classes: PropTypes.object.isRequired,
  };

  static getDerivedStateFromProps(props) {
    let newState = null;
    if (
      props.authUser
      && props.roles
      && props.errorRenters === null
      && props.errorSites === null
    ) {
      const role = props.roles[props.authUser.uid];
      newState = { ...newState, role };
      if (!props.renters && !props.pendingRenters) {
        props.getRenters(props.authUser.ma, role);
      }
      if (!props.sites && !props.pendingSites) {
        props.getSites(props.authUser.ma, role);
      }
    }
    return newState;
  }

  onSubmit = (event) => {
    const {
      site_id,
      renter_id,
      mac_address,
      padlock_number,
      number,
      rfid,
      type,
      padlock_type,
      manufacturer_id,
      is_electric,
    } = this.state;
    if (mac_address && !mac_address.match(/..:..:..:..:..:../)) {
      this.props.handleError({ message: 'L\'adresse MAC doit être au format AA:AA:AA:AA:AA:AA.' });
    } else {
      this.props.postBike(
        this.props.authUser.ma,
        {
          renter_info_id: renter_id,
          site_id,
          mac_address: mac_address || null,
          padlock_number: padlock_number || null,
          number: number || null,
          rfid: rfid || null,
          type: type,
          padlock_type: padlock_type,
          manufacturer_id: manufacturer_id || '',
          is_electric: is_electric,
        },
      )
        .then((value) => {
          if (value) {
            this.props.history.push(routes.BIKES);
          }
        });
    }
    event.preventDefault();
  };

  onSelectRenter = (event) => {
    this.setState(byPropKey('renter_id', event.target.value));
    const foundRenter = this.props.renters.find(renter => renter.id === event.target.value);
    this.setState(byPropKey(
      'sites',
      this.props.sites.filter(site => site.renter_info_id === foundRenter.id),
    ));
  };

  render() {
    const {
      sites,
      site_id,
      renter_id,
      mac_address,
      padlock_number,
      number,
      rfid,
      type,
      padlock_type,
      manufacturer_id,
      is_electric,
    } = this.state;

    const { classes, renters, pending } = this.props;
    const isInvalid = renter_id === '';
    if (pending) {
      return (<Loader />);
    } else if (renters && renters.length) {
      return (
        <form
          onSubmit={this.onSubmit}
          style={defaultStyles.center}
          className={classes.container}
        >
          <TextField
            id="renter_id"
            type="text"
            select
            label="Loueur"
            className={classes.textField}
            value={renter_id}
            onChange={this.onSelectRenter}
            helperText="Choisissez le loueur"
            margin="normal"
          >
            {renters.map(renter => (
              <MenuItem key={renter.id} value={renter.id}>
                {renter.name}
              </MenuItem>
            ))}
          </TextField>
          <TextField
            id="site_id"
            type="text"
            select
            label="Site"
            className={classes.textField}
            value={site_id}
            onChange={event => this.setState(byPropKey('site_id', event.target.value))}
            helperText="Choisissez le site"
            margin="normal"
          >
            {sites.map(site => (
              <MenuItem key={site.id} value={site.id}>
                {site.name}
              </MenuItem>
            ))}
          </TextField>
          <KobooTextField
            label="Adresse MAC"
            id="mac_address"
            onChange={event => this.setState(byPropKey('mac_address', event.target.value))}
            value={mac_address}
          />
          <KobooTextField
            label="Numéro de cadenas"
            id="padlock_number"
            onChange={event => this.setState(byPropKey('padlock_number', event.target.value))}
            value={padlock_number}
          />
          <KobooTextField
            label="Numéro de vélo"
            id="bike_number"
            onChange={event => this.setState(byPropKey('number', event.target.value))}
            value={number}
          />
          <KobooTextField
            label="RFID"
            id="rfid"
            onChange={event => this.setState(byPropKey('rfid', event.target.value))}
            value={rfid}
          />
          <TextField
            id="type"
            type="text"
            select
            label="Type de public"
            className={classes.textField}
            value={type}
            onChange={event => this.setState({ type: event.target.value })}
            SelectProps={{
              MenuProps: {
                className: classes.menu,
              },
            }}
            margin="normal"
          >
            <MenuItem key='type_adult' value={0}>
              Adulte
            </MenuItem>
            <MenuItem key='type_children' value={1}>
              Enfant
            </MenuItem>
          </TextField>
          <TextField
            id="is_electric"
            type="text"
            select
            label="Type de vélo"
            className={classes.textField}
            value={is_electric}
            onChange={event => this.setState({ is_electric: event.target.value })}
            SelectProps={{
              MenuProps: {
                className: classes.menu,
              },
            }}
            margin="normal"
          >
            <MenuItem key='type_mechanic' value={false}>
              Mécanique
            </MenuItem>
            <MenuItem key='type_electric' value={true}>
              Électrique
            </MenuItem>
          </TextField>
          <TextField
            id="padlock_type"
            type="text"
            select
            label="Type de cadenas"
            className={classes.textField}
            value={padlock_type}
            onChange={event => this.setState({ padlock_type: event.target.value })}
            SelectProps={{
              MenuProps: {
                className: classes.menu,
              },
            }}
            helperText="Choisissez le type du cadenas"
            margin="normal"
          >
            <MenuItem key='type_old' value={0}>
              Ancien
            </MenuItem>
            <MenuItem key='type_mose' value={1}>
              Koboo1
            </MenuItem>
            <MenuItem key='no-lock' value={2}>
              Pas de cadenas
            </MenuItem>
          </TextField>
          <KobooTextField
            label="Identifiant Constructeur"
            id="manufacturer_id"
            onChange={event => this.setState(byPropKey('manufacturer_id', event.target.value))}
            value={manufacturer_id}
          />
          <KobooButton disabled={this.props.sending || isInvalid} type="submit">
            {this.props.sending ?
              <Spinner style={{ parent: { margin: '4px auto 0' }, child: {} }} /> : 'Créer'}
          </KobooButton>
        </form>
      );
    }
    return (
      <Typography variant="subtitle1">
        Aucun loueur n'a été créé, veuillez en créer un <Link to={routes.RENTER_ADD}>ici</Link>.
      </Typography>);
  }
}

function mapStateToProps(state) {
  return {
    authUser: state.users.authUser,
    renters: state.renters.content,
    sites: state.sites.content,
    pending: state.renters.pending || state.sites.pending,
    sending: state.bikes.sending,
    pendingRenters: state.renters.pending,
    pendingSites: state.sites.pending,
    errorRenters: state.renters.error,
    errorSites: state.sites.error,
  };
}

export default compose(
  withAuthorization(authUser => !!authUser),
  withStyles(styles),
  connect(mapStateToProps, { postBike, getRenters, getSites }),
)(AddBikeForm);



// WEBPACK FOOTER //
// ./src/components/Bike/AddBikeForm.jsx